<template>
  <div :class="classes" v-loading="loading">
     <pt-page-title title="基因实验室检测平台">
        <router-link v-if="HAS_PERM_LAB_EDIT_PRODUCT" to="/lab-test-platform-new" slot="before-left"><el-button type="primary">新建基因实验室检测平台</el-button></router-link>
     </pt-page-title>
     <!-- 表格 -->
    <pt-lab-test-platform-table :tableLabels="currentTableLabels" ref="table">
      <template slot-scope="scope">
        <i  v-if="HAS_PERM_LAB_EDIT_PRODUCT" class="iconfont icon-dingdanchuangjian pointer" @click="goEdit(scope.row)"></i>
        <i class="iconfont icon-shanchu pointer" @click="goDelete(scope.row)"></i>
      </template>
    </pt-lab-test-platform-table>
  </div>
</template>

<script>
// 组件class前缀
import { tableLabels } from './lab-test-platform-options.js'
import ptLabTestPlatformTable from './pt-lab-test-platform-table/withData'
import { hasPermissions } from 'utils/permissions'
const prefixCls = 'pt-lab-test-platform-list'
const canNotDelete = ['ASA', 'PCR']
const PERM_LAB_EDIT_PRODUCT = 'PERM_LAB_EDIT_PRODUCT'
export default {
  name: 'pt-lab-test-platform-list',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTableLabels () {
      return tableLabels
    },
    HAS_PERM_LAB_EDIT_PRODUCT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_LAB_EDIT_PRODUCT)
    }
  },
  components: {
    ptLabTestPlatformTable
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    goEdit (data) {
      this.$router.push({ name: 'lab-test-platform-update', params: { id: data.id } })
    },
    goDelete (data) {
      if (canNotDelete.includes(data.name)) {
        this.$message.warning('该检测平台不可删除!')
        return
      }
      this.$confirm('确定要删除检测平台' + data.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let copyMethodId = data.methodId
        this.$store.dispatch('deleteLabProduct', data.id).then(res => {
          this.$store.dispatch('methodDelete', copyMethodId).then(res => {
            this.$refs.table.reload()
            this.$message.success('成功删除了检测平台' + data.name + '!')
            this.loading = false
          }).catch(err => {
            this.loading = false
            console.error(err)
            this.$message.error('删除失败!')
          })
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error('删除失败!')
        })
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
